import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialsHistory} from '../types'

export const MaterialsHistoryQueryKey = 'materialsHistory'

export const materialsHistoryQueryOptions = (plantCode: string, from: string, to: string) => ({
  queryKey: [MaterialsHistoryQueryKey, plantCode, from, to] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<MaterialsHistory>(
      `/plants/${plantCode}/materials/history`,
      {params: {from, to}, signal}
    )
    return response.data
  }
})

type Params<TReturn = MaterialsHistory> = {
  plantCode: string
  from: string
  to: string
  options?: Omit<UseQueryOptions<MaterialsHistory, AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useMaterialsHistory = <TReturn = MaterialsHistory>({
  plantCode,
  from,
  to,
  options
}: Params<TReturn>) =>
  useQuery<MaterialsHistory, AxiosError, TReturn>({
    ...materialsHistoryQueryOptions(plantCode, from, to),
    ...options
  })
